'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RichTextTool = require('./RichTextTool');

var _RichTextTool2 = _interopRequireDefault(_RichTextTool);

var _ToolSeparator = require('../../ToolSeparator');

var _ToolSeparator2 = _interopRequireDefault(_ToolSeparator);

var _richTextConstants = require('../../../../components/editor/richText/richTextConstants');

var _captionConstants = require('../../../../components/caption/captionConstants');

var _cardConstants = require('../../../../../common/cards/cardConstants');

require('./RichTextToolList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components
// Lib
var RichTextToolList = function RichTextToolList(_ref) {
    var editorKey = _ref.editorKey;

    var visibleTools = null;
    if (editorKey === _captionConstants.CAPTION_EDITOR_KEY) {
        visibleTools = _richTextConstants.INLINE_STYLE_TOOLS;
    } else if (editorKey === _cardConstants.CARD_TYPE) {
        visibleTools = _richTextConstants.RICH_STYLE_TOOLS;
    }

    if (!visibleTools) return null;

    return _react2.default.createElement(
        'div',
        { className: 'RichTextToolList' },
        visibleTools.map(function (tool) {
            return _react2.default.createElement(_RichTextTool2.default, {
                styleCommand: tool.textCommand,
                key: tool.textCommand,
                iconName: tool.iconName });
        }),
        _react2.default.createElement(_ToolSeparator2.default, null)
    );
};

// Styles


RichTextToolList.propTypes = {
    editorKey: _propTypes2.default.string
};

exports.default = RichTextToolList;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/richContentTools/RichTextToolList.js
// module id = 2249
// module chunks = 0